import * as amplitude from "@amplitude/analytics-browser";
import { IconButton } from "@mui/material";
import { DraftReturn } from "@redotech/redo-model/draft-return/draft-return";
import { ReturnType } from "@redotech/redo-model/return";
import { Button, ButtonSize, ButtonTheme } from "@redotech/redo-web/button";
import Info from "@redotech/redo-web/icon-old/info.svg";
import Logo from "@redotech/redo-web/icon-old/logo-icon.svg";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";
import * as footer from "./footer.module.css";

export const Footer = memo(function Footer({
  handleClick,
  showTooltip,
  buttonText,
  buttonDisabled,
  buttonPending,
  returnType,
  draftReturn,
  hideButton = false,
  hideBranding = false,
}: {
  handleClick: () => void;
  showTooltip: boolean;
  buttonText: string;
  buttonDisabled: boolean;
  buttonPending: boolean;
  returnType?: ReturnType;
  hideButton?: boolean;
  hideBranding?: boolean;
  draftReturn?: DraftReturn;
}) {
  const getCoverageText = () => {
    if (!draftReturn) {
      return "";
    }
    let string =
      "Because you opted in for Redo coverage at checkout, your return label ";

    const exchange = draftReturn.orders.some(
      (order) => order?.coverage?.exchange,
    );
    const storeCredit = draftReturn.orders.some(
      (order) => order?.coverage?.storeCredit,
    );
    const refund = draftReturn.orders.some((order) => order?.coverage?.refund);

    if (exchange && storeCredit && refund) {
      string += "is completely free!";
      return string;
    }
    if (exchange) {
      string += "for exchange ";
    }
    if (storeCredit) {
      if (exchange) {
        string += "or store credit ";
      } else {
        string += "for store credit ";
      }
    }
    if (refund) {
      if (exchange || storeCredit) {
        string += "or refund ";
      } else {
        string += "for refund ";
      }
    }
    string += "is completely free!";
    return string;
  };

  return (
    <div className={footer.footerContent}>
      <div className={footer.coverageText}>
        {returnType === "return" &&
        !hideBranding &&
        !!draftReturn &&
        draftReturn.orders.some((order) => order.protected) ? (
          <>
            <Logo className={footer.logo} />
            <div>Return covered for free by Redo</div>
            {showTooltip && (
              <Tooltip placement="top" title={getCoverageText()}>
                <IconButton aria-label="More information about Redo return coverage">
                  <Info className={footer.infoIcon} />
                </IconButton>
              </Tooltip>
            )}
          </>
        ) : undefined}
      </div>
      {!hideButton && (
        <div className={footer.button}>
          <Button
            className={footer.button}
            disabled={buttonDisabled}
            onClick={() => {
              if (!buttonDisabled) {
                handleClick();
                amplitude.logEvent("continue-to-return-method");
              }
            }}
            pending={buttonPending}
            size={ButtonSize.MEDIUM}
            theme={ButtonTheme.PRIMARY}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
});
